export interface ErrorInfo {
  statusCode: number;
  count: number;
  lastOccurred: number;
}

export interface ErrorSample {
  timestamp: number;
  eventName: string;
  eventType: string;
  reportedBy: string;
}

export interface IErrors {
  items?: ErrorInfo[];
  selected?: ErrorSample[];
}

interface AggregatedData {
  bucket: number;
  totalFailed: number | null;
  totalDelivered: number | null;
}

export interface EventStats {
  graph: AggregatedData[];
  totalFailed: number;
  totalDelivered: number;
  totalDeliveredWithWarning?: number;
  failureRate: number;
}

export interface EventStatsResponse {
  aggregates: AggregatedData[];
  totalFailed: number;
  totalDelivered: number;
  totalDeliveredWithWarning?: number;
}

export interface LatencyGraphPoint {
  bucket: number;
  latency?: number | null;
}

export interface LatencyStats {
  graph: LatencyGraphPoint[];
  totalLatency?: number;
}

export enum GraphTab {
  DELIVERY = 'Delivery',
  LATENCY = 'Latency',
}

export enum EventDetailsFilter {
  ALL = 'all',
  FAILURES = 'failures',
}

export type EventDetailsOrderBy =
  | 'eventName'
  | 'deliveredCount'
  | 'lastDelivered'
  | 'failedCount'
  | 'lastFailed';

export type SortOrder = 'ASC' | 'DESC';

export interface EventDetailsParams {
  failuresOnly: boolean;
  pageSize: number;
  pageNumber: number;
  orderBy?: EventDetailsOrderBy;
  sortOrder?: SortOrder;
  eventType?: string;
  searchBy?: string;
}

export interface EventDetailsType {
  eventName: string;
  eventType: string;
  deliveredCount: number;
  // Optional: absent until the reporting/config-backend contract exposes warning counts
  deliveredWithWarningCount?: number;
  failedCount: number;
  lastDelivered: number | null;
  lastFailed: number | null;
}

export interface EventFailure {
  statusCode: number;
  reportedBy: string;
  timestamp: number;
}
